import { createFileRoute } from "@tanstack/react-router";

import { AIChatThreadPage } from "src/components/AIChatThreadPage";

export const Route = createFileRoute("/_auth/_coach/ai/")({
  component: RouteComponent,
  ssr: true,
});

function RouteComponent() {
  return <AIChatThreadPage initialChat={null} />;
}
